var oParams = {
    localOfFiles: "https://3d.diverge-sneakers.com/",
    viewerEl: "product-image-customize",
    viewerDisableWarnings: !0,
    viewerCameraDistance: isMobile() ? 110 : 100,
    viewerCameraInitialPosition: "left",
    viewerCameraSymbolPosition: "top-back",
    viewerApplySelectedMatColors: !0,
    viewerObjectRePosition: !0,
    viewerObjectPosition: "-35px 0px 0px 0px",
    scrollColorsEnable: isMobile(),
    scrollColorsMaxWidth: "1000px",
    loaderFadeTime: 300,
    productType: "minimal_low" == window.productType ? "minimal" : window.productType,
    mouseOverApplyColors: !0,
    symbolBackgroundUrl: $(".symbol-modal").css("background-image"),
    symbolColor: "0xffffff",
    dispatchResizeEvent: !0,
};
function struct_n() {
    return !pSteps.step6["laces-colorSettings"];
}
function isFacebookApp() {
    var e = navigator.userAgent || navigator.vendor || window.opera;
    return console.info("User Agent: " + e), e.indexOf("FBAN") > -1 || e.indexOf("FBAV") > -1;
}
function isInstagramApp() {
    return (navigator.userAgent || navigator.vendor || window.opera).indexOf("Instagram") > -1;
}
function changeShoeMaterialColor(e, t, o, a) {
    if (("landscape" == oParams.productType || "now" == oParams.productType || "now_vegan" == oParams.productType) && "inline" == e)
        switch (t) {
            case "0xFBFBFB":
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xF5F3E7");
                break;
            case "0x141417":
            default:
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0x141417");
                break;
            case "0xDECEB4":
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xE7E2CE");
        }
    if ("ziggy" == oParams.productType && "inline" == e)
        switch (t) {
            case "0xFBFBFB":
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xF5F3E7");
                break;
            case "0x141417":
            default:
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0x141417");
                break;
            case "0xDECEB4":
                DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xE7E2CE");
        }
    if (
        (("minimal" != oParams.productType && "minimal_high" != oParams.productType) ||
            setTimeout(function () {
                DIVERGEVIEWER.changeShoeMaterialColor("logo_insole", "0x000000");
            }, 100),
        "landscape_canvas" != oParams.productType && "slip_on" != oParams.productType && ("laces_base_color" == e || "laces_pattern" == e))
    )
        return DIVERGEVIEWER.changeShoeMaterialColor(e, t);
    var r;
    if ("landscape_canvas" == oParams.productType) {
        if ("laces" == e)
            return (
                setTimeout(function () {
                    DIVERGEVIEWER.changeShoeMaterialColor(e, t);
                }, 200),
                !0
            );
        a && "canvas" == e && ((a = a.replace("region-", "").replace("-materialSettings", "").replace("canvas", "")), (r = String.fromCharCode(96 + parseInt(a))), (e = "area_" + r)),
            a || "canvas" != e || (e = "area_" + String.fromCharCode(96 + parseInt(o.split("region_")[1]))),
            a &&
                "suede" == e &&
                "step_1_region_5" == t &&
                (DIVERGEVIEWER.changeShoeMaterialColor("detail_area_a", t), (a = a.replace("region-", "").replace("-materialSettings", "").replace("suede", "")), (r = String.fromCharCode(96 + parseInt(a))), (e = "area_" + r));
    }
    "landscape" == oParams.productType || "landscape_canvas" == oParams.productType
        ? (DIVERGEVIEWER.changeShoeMaterialColor("logos_container", "0x000000"),
          "landscape_canvas" == oParams.productType && (e = e.replace("_base_color", "")),
          is_v4 ? DIVERGEVIEWER.changeShoeMaterialColor("detail_area_a", "0x768A93") : DIVERGEVIEWER.changeShoeMaterialColor("detail_area_a", "0xD6D2C9"),
          "area_e" == e && DIVERGEVIEWER.changeShoeMaterialColor("detail_area_a", "0xD6D2C9"),
          DIVERGEVIEWER.changeShoeMaterialColor(e, t))
        : DIVERGEVIEWER.changeShoeFabricColor(o, t),
        "landscape_canvas" == oParams.productType &&
            setTimeout(function () {
                DIVERGEVIEWER.changeShoeMaterialColor("inline", "0xFFFCDD");
            }, 200);
}
function tryGetMaterial(e) {
    if ("landscape_canvas" == oParams.productType && "suede" == e) return "area_e";
    for (var t = DIVERGEVIEWER.getAvailableShoeMaterials(), o = 0; o < t.length; o++) {
        if ("insole" == t[o] && "sole" == e) return "sole";
        if (-1 !== t[o].indexOf(e)) return t[o];
    }
    return !1;
}
function matchMaterial(e) {
    if (window.currentStep && tryGetMaterial(matchStep(window.currentStep))) return tryGetMaterial(matchStep(currentStep));
    switch (e) {
        case "polyester":
        case "lining":
        case "cotton":
            return tryGetMaterial("inline");
        case "rubber":
            return tryGetMaterial("sole");
        case "leather":
            return tryGetMaterial("leather");
        case "suede":
            return tryGetMaterial("suede");
        case "floater":
            return tryGetMaterial("floater");
        case "nubuck":
            return tryGetMaterial("nabuk");
        default:
            return e;
    }
}
function matchStep(e) {
    switch (e) {
        case 1:
            return "upper";
        case 2:
            return "heel-panel";
        case 3:
            return "sole";
        case 4:
            return "stitching";
        case 5:
            return "lining";
        case 6:
            return "laces";
        case 7:
            return "elastic";
        case 8:
            return "front-panel";
        case 9:
            return "symbol";
        default:
            return e;
    }
}
function isMobile() {
    return $(window).innerWidth() <= 896;
}
function changePositionObject() {
    $("#" + oParams.viewerEl)
        .find("canvas")
        .css("margin", oParams.viewerObjectPosition);
}
function initializeDivergeViewerWithColors() {
    $(".zopim").hide(),
        $("#PageContainer").attr("style", "margin-top: 0px !important;"),
        struct_n() || $('.landscape .values-controls div[data-step="6"][data-regions-info="region-1-materialSettings"]').addClass("no-vs"),
        oParams.viewerDisableWarnings &&
            ((console.warn = function (e, t) {
                return DIVERGEVIEWER.warn || (DIVERGEVIEWER.warn = { error: e, stack: t }), !0;
            }),
            (console.log = function (e, t) {
                return DIVERGEVIEWER.log || (DIVERGEVIEWER.log = { log: e, stack: t }), !0;
            }));
    if (($("#shopify-section-header").css("z-index", "0"), DIVERGEVIEWER.inicialized)) return "function" == typeof window.Event && window.dispatchEvent(new Event("resize")), $(".loader").fadeOut(oParams.loaderFadeTime), !0;
    DIVERGEVIEWER.loadConfigurationFiles(oParams.localOfFiles, function () {
        DIVERGEVIEWER.init(
            oParams.viewerEl,
            function (e) {
                setTimeout(function () {
                    "function" == typeof window.Event && window.dispatchEvent(new Event("resize"));
                }, 500),
                    "ziggy" == oParams.productType &&
                        setTimeout(function () {
                            DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xF5F3E7"), DIVERGEVIEWER.changeShoeMaterialColor("holder_side_logos", "0x000000");
                        }, 300),
                    ("landscape_canvas" != oParams.productType && "twist_low" != oParams.productType) ||
                        setTimeout(function () {
                            DIVERGEVIEWER.changeShoeMaterialColor("insole", "0xEBE9C7");
                        }, 300),
                    (cProduct = jQuery.extend({}, pSteps)),
                    $(".customize-controls-area").css("pointer-events", "initial"),
                    $(".customize-product-wrapper").css("pointer-events", "initial"),
                    $(".drag-spin").show(),
                    setTimeout(function () {
                        $(".drag-spin").show();
                    }, 30),
                    (DIVERGEVIEWER.inicialized = !0),
                    !isMobile() && DIVERGEVIEWER.setMinCameraDistance && DIVERGEVIEWER.setMinCameraDistance(50),
                    DIVERGEVIEWER.selectCameraPosition && (isMobile() ? DIVERGEVIEWER.selectCameraPosition("leftm") : DIVERGEVIEWER.selectCameraPosition(oParams.viewerCameraInitialPosition)),
                    oParams.symbolColor && DIVERGEVIEWER.changeShoeMaterialColor("custom_logo_mat", oParams.symbolColor),
                    oParams.viewerObjectRePosition && changePositionObject();
                var t = DIVERGEVIEWER.getAvailableShoeMaterials();
                if (
                    ("landscape_canvas" == oParams.productType && t.push("canvas"),
                    $("#scene").remove(),
                    $(".loader").fadeOut(300),
                    oParams.dispatchResizeEvent &&
                        setTimeout(function () {
                            "function" == typeof window.Event && window.dispatchEvent(new Event("resize"));
                        }, 500),
                    !oParams.viewerApplySelectedMatColors)
                )
                    return !0;
                if (struct_n()) {
                    console.info("Shoe running with new data structure.");
                    var o = [];
                    setTimeout(function () {
                        if ("minimal" == oParams.productType || "minimal_high" == oParams.productType) {
                            var e = pSteps.step1["region-2-materialSelected"];
                            void 0 !== e && ((o = e.split(":")), console.info("selected material " + o[1]), DIVERGEVIEWER.changeShoeFabric("step_2_region_1", o[1]));
                        }
                    }, 200),
                        setTimeout(function () {
                            (window.nftHashObject = JSON.stringify(window.cProduct)),
                                (window.originalHash = CryptoJS.MD5(formatNftHash(window.nftHashObject)).toString(CryptoJS.enc.Base64)),
                                (window.nftHash = window.originalHash),
                                console.error("hash initial: " + window.originalHash);
                        }, 1500),
                        setTimeout(function () {
                            for (var e in pSteps)
                                if (Object.keys(pSteps[e]).length)
                                    for (var t in pSteps[e])
                                        if (-1 !== t.indexOf("materialSelected")) {
                                            var o = pSteps[e][t].split(":");
                                            if (
                                                ($(
                                                    $('[data-step="' + e.replace("step", "step-") + '"][data-button="' + t.replace("materialSelected", "materialSettings") + '"]')
                                                        .find("span")
                                                        .get(0)
                                                ).html(o[1]),
                                                "step" + e.replace("step", "") != "step6" ? (cProduct["step" + e.replace("step", "")][o[1]] = "") : (cProduct["step" + e.replace("step", "")].laces = ""),
                                                DIVERGEVIEWER.changeShoeFabric &&
                                                    -1 !== t.indexOf("region") &&
                                                    -1 !== DIVERGEVIEWER.getAvailableShoeMaterials().indexOf(o[1].replace("-", "_")) &&
                                                    DIVERGEVIEWER.changeShoeFabric("step_" + e.replace("step", "") + "_" + t.replace("-materialSelected", "").replace("-", "_"), o[1].replace("-", "_")),
                                                DIVERGEVIEWER.changeShoeFabric &&
                                                    -1 !== t.indexOf("region") &&
                                                    "twist_low" != oParams.productType &&
                                                    DIVERGEVIEWER.changeShoeFabric("step_" + e.replace("step", "") + "_" + t.replace("-materialSelected", "").replace("-", "_"), o[1].replace("-", "_")),
                                                o[2])
                                            ) {
                                                var a = o[2].split("/")[0];
                                                $('.regions-controls [data-step="' + e.replace("step", "step-") + '"][data-button="' + t.replace("materialSelected", "materialSettings") + '"] .region-color-label').html(
                                                    a.lastIndexOf(":") ? a.substring(a.lastIndexOf(":") + 1) : a
                                                );
                                                var r = o[2].split("/")[1];
                                                a = o[2].split("/")[0];
                                                if ("step" + e.replace("step", "") == "step6")
                                                    (cProduct["step" + e.replace("step", "")].laces = r.replace("#", "0x").replace(",", "").replace(";", "")),
                                                        tinycolor(r.split(";")[0]).isLight()
                                                            ? ($(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] span").attr(
                                                                  "style",
                                                                  "color: #000000 !important;"
                                                              ),
                                                              $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] .region-color-label").attr(
                                                                  "style",
                                                                  "color: #000000 !important;"
                                                              ),
                                                              (a = o[2].split("/")[0]),
                                                              $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] .region-color-label").html(
                                                                  a.lastIndexOf(":") ? a.substring(a.lastIndexOf(":") + 1) : a
                                                              ))
                                                            : ((a = o[2].split("/")[0]),
                                                              $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] .region-color-label").html(
                                                                  a.lastIndexOf(":") ? a.substring(a.lastIndexOf(":") + 1) : a
                                                              ),
                                                              $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] span").attr(
                                                                  "style",
                                                                  "color: #ffffff !important;"
                                                              ),
                                                              $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] .region-color-label").attr(
                                                                  "style",
                                                                  "color: #ffffff !important;"
                                                              )),
                                                        $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings']").css(
                                                            "backgroundColor",
                                                            r.replace(",", "").replace(";", "")
                                                        ),
                                                        DIVERGEVIEWER.changeShoeFabricColor(
                                                            "step_" + e.replace("step", "") + "_" + t.replace("-materialSelected", "").replace("-", "_"),
                                                            r.replace("#", "0x").replace(",", "").replace(";", "")
                                                        ),
                                                        "step_" + e.replace("step", "") + "_" + t.replace("-materialSelected", "").replace("-", "_") == "step_6_region_2" &&
                                                            -1 !== DIVERGEVIEWER.getAvailableShoePartsList().indexOf("step_6_region_2") &&
                                                            "pride" == a &&
                                                            ($(".bk-pride").addClass("sel-color"), DIVERGEVIEWER.changeShoeFabric("step_6_region_2", "pride"));
                                                else
                                                    struct_n() || (cProduct["step" + e.replace("step", "")][o[1]] = r.replace("#", "0x").replace(",", "").replace(";", "")),
                                                        tinycolor(r.replace(",", "").replace(";", "")).isLight()
                                                            ? $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] span").attr(
                                                                  "style",
                                                                  "color:black !important;"
                                                              )
                                                            : $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings'] span").attr(
                                                                  "style",
                                                                  "color:white !important;"
                                                              ),
                                                        $(".regions-step-" + e.replace("step", "") + "-controls.regions-controls li[data-button='" + t.replace("-materialSelected", "") + "-materialSettings']").css(
                                                            "backgroundColor",
                                                            r.replace(",", "").replace(";", "")
                                                        ),
                                                        DIVERGEVIEWER.changeShoeFabricColor(
                                                            "step_" + e.replace("step", "") + "_" + t.replace("-materialSelected", "").replace("-", "_"),
                                                            r.replace("#", "0x").replace(",", "").replace(";", "")
                                                        );
                                            }
                                        }
                            if (
                                (oParams.symbolColor && DIVERGEVIEWER.changeShoeMaterialColor("custom_logo_mat", oParams.symbolColor),
                                Object.keys(pSteps.step6).length &&
                                    (changeShoeMaterialColor(matchMaterial("laces_base_color"), pSteps.step6["region-1-materialSelected"].split(":")[2].split(";")[0].split("/")[1].replace("#", "0x")),
                                    pSteps.step6["region-1-materialSelected"].split(":")[2].split(";")[1] &&
                                        changeShoeMaterialColor(matchMaterial("laces_pattern"), pSteps.step6["region-1-materialSelected"].split(":")[2].split(";")[1].split("/")[1].replace("#", "0x"))),
                                "now" == window.productType || "now_vegan" == window.productType)
                            )
                                for (var i = 0; i < $(".regions-controls li").length; i++)
                                    tinycolor($($(".regions-controls li")[i]).css("background-color")).isLight() ? $($(".regions-controls li")[i]).addClass("act") : $($(".regions-controls li")[i]).removeClass("act");
                        }, 100);
                } else {
                    for (var a in pSteps)
                        if (Object.keys(pSteps[a]).length)
                            for (var r = 0; r < Object.keys(pSteps[a]).length; r++)
                                if (pSteps[a]["region-" + r + "-colorSettings"])
                                    if (-1 !== t.indexOf(matchMaterial(pSteps[a]["region-" + r + "-materialSelected"]))) {
                                        $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-" + r + "-materialSettings']").css(
                                            "backgroundColor",
                                            pSteps[a]["region-" + r + "-colorSelected"].split("/")[1]
                                        ),
                                            tinycolor(pSteps[a]["region-" + r + "-colorSelected"].split("/")[1]).isLight()
                                                ? $(".regions-controls span").attr("style", "color:black !important;")
                                                : $(".regions-controls span").attr("style", "color:white !important;"),
                                            changeShoeMaterialColor(
                                                matchMaterial(pSteps[a]["region-" + r + "-materialSelected"]),
                                                pSteps[a]["region-" + r + "-colorSelected"].split("/")[1].replace("#", "0x"),
                                                "step_" + a.replace("step", "") + "_region_" + r
                                            );
                                        var i = pSteps[a]["region-" + r + "-colorSelected"].split("/")[0];
                                        $('.regions-controls [data-step="' + a.replace("step", "step-") + '"][data-button="region-' + r + '-materialSettings"] .region-color-label').html(
                                            i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i
                                        ),
                                            cProduct[a] || (cProduct[a] = {}),
                                            (cProduct[a]["region-" + r] = pSteps[a]["region-" + r + "-colorSelected"].split("/")[1]);
                                    } else console.log("MATERIAL NOT FOUND ON DIVERGEVIEWER: " + pSteps[a]["region-" + r + "-materialSelected"] + " does not match " + matchMaterial(pSteps[a]["region-" + r + "-materialSelected"]));
                                else {
                                    var s = "";
                                    for (var l in pSteps[a]) -1 !== l.indexOf("colorSelected") && -1 === l.indexOf("region") && (s = l.split("-")[0]);
                                    if (s) {
                                        if (
                                            ($(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings']").css("backgroundColor", pSteps[a][s + "-colorSelected"].split("/")[1]),
                                            tinycolor(pSteps[a][s + "-colorSelected"].split("/")[1]).isLight()
                                                ? ($(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] span").attr("style", "color: #000000 !important"),
                                                  $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] .region-color-label").css("color", "#000000 !important"))
                                                : ($(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] span").attr("style", "color: #ffffff !important"),
                                                  $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] .region-color-label").css("color", "#ffffff !important")),
                                            "laces" == s)
                                        )
                                            $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings']").css(
                                                "backgroundColor",
                                                pSteps[a][s + "-colorSelected"].split("/")[1].split(";")[0]
                                            ),
                                                tinycolor(pSteps[a][s + "-colorSelected"].split("/")[1].split(";")[0]).isLight()
                                                    ? ($(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] span").attr("style", "color: #000000 !important"),
                                                      $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] .region-color-label").css("color", "#000000 !important"))
                                                    : ($(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] span").attr("style", "color: #ffffff !important"),
                                                      $(".regions-step-" + a.replace("step", "") + "-controls.regions-controls li[data-button='region-1-materialSettings'] .region-color-label").css("color", "#ffffff !important")),
                                                (n = (n = pSteps[a][s + "-colorSelected"].split(";")[0]).split("/")[1].replace("#", "0x")),
                                                (c = (c = pSteps[a][s + "-colorSelected"].split(";")[1]).split("/")[1].replace("#", "0x")),
                                                changeShoeMaterialColor("laces", n ? n.replace("#", "0x") : ""),
                                                n == c
                                                    ? setTimeout(function () {
                                                          DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "no_material");
                                                      }, 200)
                                                    : DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "default");
                                        if (-1 !== t.indexOf(matchMaterial(s))) {
                                            $('.values-controls [data-button="' + s + '-colorSettings"][data-color="' + pSteps[a][s + "-colorSelected"].split("/")[1] + '"]').addClass("value-active");
                                            i = pSteps[a][s + "-colorSelected"].split("/")[0];
                                            if (
                                                ($('.regions-controls [data-step="' + a.replace("step", "step-") + '"][data-button="region-1-materialSettings"] .region-color-label').html(
                                                    i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i
                                                ),
                                                changeShoeMaterialColor(matchMaterial(s), pSteps[a][s + "-colorSelected"].split("/")[1].replace("#", "0x")),
                                                cProduct[a] || (cProduct[a] = {}),
                                                "laces" == s)
                                            )
                                                (n = (n = pSteps[a][s + "-colorSelected"].split(";")[0]).split("/")[1].replace("#", "0x")),
                                                    (c = (c = pSteps[a][s + "-colorSelected"].split(";")[1]).split("/")[1].replace("#", "0x")),
                                                    changeShoeMaterialColor(matchMaterial("laces_base_color"), n ? n.replace("#", "0x") : ""),
                                                    changeShoeMaterialColor(matchMaterial("laces_pattern"), c ? c.replace("#", "0x") : "");
                                            else cProduct[a].color = pSteps[a][s + "-colorSelected"].split("/")[1].replace("#", "0x");
                                        }
                                        if ("laces" == s && "landscape_canvas" != oParams.productType) {
                                            (n = (n = pSteps[a][s + "-colorSelected"].split(";")[0]).split("/")[1].replace("#", "0x")),
                                                (c = (c = pSteps[a][s + "-colorSelected"].split(";")[1]).split("/")[1].replace("#", "0x")),
                                                cProduct[a] || (cProduct[a] = {}),
                                                (cProduct[a].colorOne = n),
                                                (cProduct[a].colorTwo = c);
                                            i = pSteps[a][s + "-colorSelected"].split("/")[0];
                                            $('.regions-controls [data-step="' + a.replace("step", "step-") + '"][data-button="region-1-materialSettings"] .region-color-label').html(
                                                i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i
                                            ),
                                                changeShoeMaterialColor(matchMaterial("laces_base_color"), n.replace("#", "0x")),
                                                changeShoeMaterialColor(matchMaterial("laces_pattern"), c.replace("#", "0x")),
                                                n == c
                                                    ? setTimeout(function () {
                                                          DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "no_material");
                                                      }, 200)
                                                    : DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "default");
                                        }
                                    }
                                }
                    var n, c;
                    if (pSteps.step6["laces-colorSelected"] && "landscape_canvas" != oParams.productType)
                        (n = (n = pSteps.step6["laces-colorSelected"].split(";")[0]).split("/")[1].replace("#", "0x")),
                            (c = (c = pSteps.step6["laces-colorSelected"].split(";")[1]).split("/")[1].replace("#", "0x")),
                            changeShoeMaterialColor(matchMaterial("laces_base_color"), n.replace("#", "0x")),
                            changeShoeMaterialColor(matchMaterial("laces_pattern"), c.replace("#", "0x"));
                }
                oParams.mouseOverApplyColors &&
                    !isMobile() &&
                    ($(".values-controls .bbb").on("mouseover touchmove touchend", function (e) {
                        (window.colorMouseOver = !0), $(e.target).click();
                    }),
                    $(".values-controls .bbb").on("mouseleave", function (e) {
                        window.lastColorEl && lastColorEl.click();
                    })),
                    setTimeout(function () {
                        $(".product-image-customize").attr("style", "display: block !important;"), "function" == typeof window.Event && window.dispatchEvent(new Event("resize"));
                    }, 200),
                    window.cProduct.step9 &&
                        (window.cProduct.step9.firstWord || (window.cProduct.step9.firstWord = ""),
                        window.cProduct.step9.lastWord || (window.cProduct.step9.lastWord = ""),
                        window.no_symbol
                            ? (DIVERGEVIEWER.changeTexture("step_9_region_1_text_logo", "https://3d.diverge-sneakers.com/text.image.php?first_word=Skullfades&last_word=Logo"), $(".symbol-input").val("Skullfades\nLogo"))
                            : (DIVERGEVIEWER.changeTexture("step_9_region_1_text_logo", "https://3d.diverge-sneakers.com/text.image.php?first_word=" + window.cProduct.step9.firstWord + "&last_word=" + window.cProduct.step9.lastWord),
                              $(".symbol-input").val(window.cProduct.step9.firstWord + "\n" + window.cProduct.step9.lastWord))),
                    setTimeout(function () {
                        var e, t;
                        for (a in pSteps)
                            for (obn in pSteps[a])
                                if (
                                    (-1 !== obn.indexOf("-name") &&
                                        $($('.regions-controls li[data-step="' + a.replace("step", "step-") + '"][data-button="' + obn.replace("-name", "") + '-materialSettings"] span')[0]).html(
                                            pSteps[a][obn] + " | " + pSteps[a][obn.replace("-name", "-materialSelected")].split(":")[1]
                                        ),
                                    -1 !== obn.indexOf("materialSelected"))
                                ) {
                                    if (pSteps[a][obn].split("/").length > 2) {
                                        var o = pSteps[a][obn].split("/")[1].split(";")[0].replace(";", ""),
                                            r = pSteps[a][obn].split("/")[2].split(";")[0].replace(";", "");
                                        e = $(
                                            '.values-controls div[data-step="' +
                                                a.replace("step", "") +
                                                '"][data-button="' +
                                                obn.replace("-materialSelected", "") +
                                                '-materialSettings"][data-color-one="' +
                                                o +
                                                '"][data-color-two="' +
                                                r +
                                                '"]'
                                        ).addClass("sel-color");
                                    } else {
                                        var i = pSteps[a][obn].split("/")[1].replace(";", "");
                                        e = $('.values-controls div[data-step="' + a.replace("step", "") + '"][data-button="' + obn.replace("-materialSelected", "") + '-materialSettings"][data-color="' + i + '"]').addClass("sel-color");
                                    }
                                    $(e).data("color-name") &&
                                        ((t =
                                            -1 !== $(e).data("color-name").indexOf(":")
                                                ? $(e)
                                                      .data("color-name")
                                                      .substring($(e).data("color-name").lastIndexOf(":") + 1, $(e).data("color-name").length)
                                                : $(e).data("color-name")),
                                        $('.regions-controls li[data-step="' + a.replace("step", "step-") + '"][data-button="' + obn.replace("-materialSelected", "") + '-materialSettings"] .region-color-label').html(t || ""));
                                }
                    }, 1e3);
            },
            oParams.productType
        );
    });
}
(window.sizeSelector = !1),
    $(document).ready(function () {
        $(".size-selector-product").click(function (e) {
            window.sizeSelector = !0;
        }),
            (window.sizes = !1),
            $(".size-selector option").each(function (e, t) {
                window.sizes ? (window.sizes = sizes + "," + t.value) : (window.sizes = t.value);
            });
        for (var e = 0; e < $(".principal-controls ul li").length; e++) $($(".principal-controls ul li")[e]).html().length > 8 && $($(".principal-controls ul li")[e]).addClass("no-m");
        $(".tooltip").hover(function () {
            $(window.document).find(".tooltiptext").css("visibility", "hidden"),
                $(window.document).find(".tooltiptext").css("opacity", "0"),
                $(this).find(".tooltiptext").css("visibility", "visible"),
                $(this).find(".tooltiptext").css("opacity", "1");
        }),
            $(".customize-controls-area").css("pointer-events", "none"),
            $(".customize-product-wrapper").css("pointer-events", "none"),
            $(".symbol-input").on("paste", function (e) {
                e.preventDefault(), alert("Please write your text.");
            }),
            $(".symbol-input").keyup(function (e) {
                $(e.target).val().split("\n").length >= 3 && $(".symbol-input").val($(e.target).val().split("\n")[0] + "\n" + $(e.target).val().split("\n")[1]);
            }),
            $(".symbol-input").change(function (e) {
                -1 !== $(e.target).val().indexOf("\n") ? (window.cProduct.step9.firstWord = $(e.target).val().split("\n")[0]) : (window.cProduct.step9.firstWord = $(e.target).val().substring(0, 12));
            }),
            $(".symbol-input").change(function (e) {
                -1 !== $(e.target).val().indexOf("\n") ? (window.cProduct.step9.lastWord = $(e.target).val().split("\n")[1]) : (window.cProduct.step9.lastWord = $(e.target).val().substring(13, 25));
            }),
            $(".button-customize").on("click", function () {
                $("body.template-product").css({ overflow: "auto" }),
                    $("body").css({ overflow: "auto" }),
                    window.scrollTo(0, 0),
                    window.variantSel && $(".size-selector").val(window.variantSel.title),
                    fixUIwebview(),
                    $(".price-c").html($($(".money")[0]).html()),
                    $(".logo--left").hide(),
                    $(".inner-customize-content-area").hide(),
                    $(".customize-product").fadeIn(oParams.loaderFadeTime, function () {}),
                    window.variantSel && $(".size-selector").val(window.variantSel.title),
                    (window.countN = 0),
                    (window.interv = setInterval(function () {
                        window.variantSel && $(".size-selector").val(window.variantSel.title.split("/")[0].replace(" ", "")), window.countN++, window.countN > 50 && clearInterval(window.interv);
                    }, 10)),
                    $(".loader").fadeIn(oParams.loaderFadeTime, function () {
                        initializeDivergeViewerWithColors();
                    }),
                    $("#shopify-section-header").addClass("no-index"),
                    $(".grid.product-single").hide(),
                    $(".tabs-details-product").hide(),
                    $(".grid.grid--no-gutters").hide(),
                    $("body.template-product").css({ overflow: "hidden" }),
                    $("body").css({ overflow: "hidden" }),
                    $($(".size-selector")[0]).val($($('[data-index="option1"]')[1]).val()),
                    (showLoader = setTimeout(function () {
                        $(".inner-customize-content-area").fadeIn(550, function () {
                            "function" == typeof window.Event && window.dispatchEvent(new Event("resize"));
                        }),
                            setTimeout(function () {
                                "function" == typeof window.Event && window.dispatchEvent(new Event("resize"));
                            }, 600),
                            $($(".size-selector")[0]).val($($('[data-index="option1"]')[1]).val());
                    }, 500));
            }),
            $(".principal-controls ul")
                .children("li:not(.have-regions)")
                .on("click", function (e) {
                    e.preventDefault(),
                        e.stopPropagation(),
                        $(".symbol-input").val(""),
                        $(window.document).find(".tooltiptext").css("visibility", "hidden"),
                        $(window.document).find(".tooltiptext").css("opacity", "0"),
                        $(".materials-controls").hide(),
                        $(".drag-spin").css("display", "none");
                    var t = $(this).attr("data-button");
                    "step-9-controls" == t
                        ? (DIVERGEVIEWER.setMinCameraDistance && DIVERGEVIEWER.setMinCameraDistance(70),
                          DIVERGEVIEWER.selectCameraPosition && DIVERGEVIEWER.selectCameraPosition(oParams.viewerCameraSymbolPosition),
                          revertSymbolDom(oParams.symbolBackgroundUrl),
                          $(".symbol-modal").show())
                        : ($(".symbol-modal").is(":visible") && ($(".symbol-modal").fadeOut(), DIVERGEVIEWER.selectCameraPosition && DIVERGEVIEWER.selectCameraPosition(oParams.viewerCameraInitialPosition)), $(".symbol-modal").fadeOut()),
                        $(this).parent().children().removeClass("step-active"),
                        $(this).addClass("step-active"),
                        $(".regions-controls").hide(),
                        $(".values-controls").hide(),
                        $(".values-" + t).fadeToggle(),
                        !$(".values-" + t)
                            .children("ul")
                            .children("li.value-active").length > 0 &&
                            $(".values-" + t)
                                .children("ul")
                                .children("li")
                                .first()
                                .addClass("value-active");
                }),
            $(".principal-controls ul")
                .children("li.have-regions")
                .on("click", function (e) {
                    e.preventDefault(),
                        e.stopPropagation(),
                        $(window.document).find(".tooltiptext").css("visibility", "hidden"),
                        $(window.document).find(".tooltiptext").css("opacity", "0"),
                        $(".materials-controls").hide(),
                        $(".symbol-modal").is(":visible") && ($(".symbol-modal").fadeOut(), DIVERGEVIEWER.selectCameraPosition && DIVERGEVIEWER.selectCameraPosition(oParams.viewerCameraInitialPosition)),
                        $(".drag-spin").css("display", "none");
                    var t = $(this).attr("data-button");
                    $(this).parent().children().removeClass("step-active"),
                        $(this).addClass("step-active"),
                        $(".values-controls").hide(),
                        $(".regions-controls")
                            .not(".regions-" + t)
                            .hide(),
                        $(".regions-" + t).fadeToggle();
                    var o = t.split("-");
                    if (
                        ((o = o[1]),
                        $(".regions-step-" + o + "-controls.regions-controls ul li")
                            .first()
                            .addClass("active"),
                        $(".regions-step-" + o + "-controls.regions-controls ul li").length)
                    ) {
                        $(".regions-step-" + o + "-controls.regions-controls ul li")
                            .first()
                            .trigger("click")
                            .trigger("click")
                            .addClass("active");
                        for (var a = pSteps.step1["region-1-materialSelected"].split(":")[1], r = $(".materials-step-" + o + '-controls.materials-controls ul li[data-region="region-1-materialSettings"]'), i = 0; i < r.length; i++)
                            $(r[i]).find("span").html().trim() == a.trim() && $(r[i]).trigger("click").trigger("click").addClass("active");
                    }
                }),
            $(".regions-controls ul")
                .children("li")
                .on("click", function (e) {
                    e.preventDefault(),
                        e.stopPropagation(),
                        $(window.document).find(".tooltiptext").css("visibility", "hidden"),
                        $(window.document).find(".tooltiptext").css("opacity", "0"),
                        $(".regions-controls ul").children("li").removeClass("active"),
                        $(e.delegateTarget).addClass("active"),
                        $(".materials-controls").css("display", "none").hide(),
                        $(".ffft").css("display", "none").hide();
                    var t = $(this).attr("data-button"),
                        o = $(this).attr("data-step"),
                        a = $(this).attr("data-one-material");
                    if (a && "true" == a)
                        $(".values-" + o + "-controls." + t)
                            .find("li")
                            .click();
                    else {
                        $(".materials-" + o + "-controls")
                            .css("display", "initial")
                            .show(),
                            $("." + t)
                                .css("display", "initial")
                                .show();
                        for (var r = 0; r < $('[data-step="' + o + '"][data-region="' + t + '"').length; r++)
                            $($('[data-step="' + o + '"][data-region="' + t + '"')[r])
                                .find("span")
                                .html()
                                .trim() == pSteps.step1[t.replace("materialSettings", "materialSelected")].split(":")[1] && $($('[data-step="' + o + '"][data-region="' + t + '"')[r]).click();
                    }
                }),
            $(".regions-controls ul")
                .children("li")
                .each(function () {
                    var e = $(this).attr("data-button"),
                        t = $(".values-controls ul")
                            .children("li[data-button='" + e + "']")
                            .first()
                            .children("span")
                            .text();
                    $(this).css({ "background-color": t }),
                        $(this).append("<span class='region-color-label'>" + t + "</span>"),
                        (function (e, t) {
                            "yellow" == t || "white" == t || "beige" == t || "lightgrey" == t || "pink" == t || "bisque" == t ? $(e).css({ color: "#777777" }) : $(e).css({ color: "#fff" });
                        })($(this), t),
                        $(".values-step-1-controls ul")
                            .children('li[data-color="' + t + '"][data-button="' + e + '"]')
                            .css({ "border-color": "#fff" });
                }),
            $(".ffft ul")
                .children("li")
                .on("click", function (e) {
                    $(window.document).find(".tooltiptext").css("visibility", "hidden"), $(window.document).find(".tooltiptext").css("opacity", "0");
                    var t,
                        o = $(this).attr("data-region"),
                        a = $(this).attr("data-step"),
                        r = $(this).find("span").html().trim(),
                        i = !1;
                    if (($(".bbb").css("display", "none"), oParams.scrollColorsEnable)) {
                        $(".values-" + a + '-controls div[data-regions-info="' + o + '"][data-material="' + r + '"]')
                            .css("display", "inline")
                            .parent()
                            .addClass("fon");
                        for (var s = 0; s < $(".tooltip.fon").length; s++) $($(".tooltip.fon")[s]).width() || $($(".tooltip.fon")[s]).attr("style", "display: none !important");
                        $(".values-controls ul").css("display", "inline-block").css("width", oParams.scrollColorsMaxWidth), $(".values-controls").css("overflow-x", "scroll").css("height", "64px").scrollLeft(0);
                    } else {
                        $(".tooltip").hide();
                        for (s = 0; s < $(".values-" + a + '-controls div[data-regions-info="' + o + '"][data-material="' + r + '"]').length; s++)
                            $($(".values-" + a + '-controls div[data-regions-info="' + o + '"][data-material="' + r + '"]')[s])
                                .closest(".tooltip")
                                .show();
                        $(".values-" + a + '-controls div[data-regions-info="' + o + '"][data-material="' + r + '"]').css("display", "initial");
                    }
                    for (var l = 0; l < $(".values-" + a + '-controls [data-regions-info="' + o + '"][data-material="' + r + '"]').length; l++) {
                        var n = $($(".values-" + a + '-controls [data-regions-info="' + o + '"][data-material="' + r + '"]')[l]);
                        n.hasClass("sel-color") && (i = n);
                    }
                    i ? i.click() : $($(".values-" + a + '-controls div[data-regions-info="' + o + '"][data-material="' + r + '"]').get(0)).click(),
                        "step-3" == a &&
                            ("now" == oParams.productType || "now_vegan" == oParams.productType) &&
                            $(".values-" + a + "-controls.values-controls").find(".tooltip").length > 1 &&
                            $(".values-" + a + "-controls.values-controls .tooltip")
                                .last()
                                .remove(),
                        $(".values-" + a + "-controls.values-controls").css("display", "block"),
                        "step-6" == a &&
                            "now" != oParams.productType &&
                            "now_vegan" != oParams.productType &&
                            "ziggy" != oParams.productType &&
                            "twist_low" != oParams.productType &&
                            "twist_high" != oParams.productType &&
                            $(".values-" + a + "-controls.values-controls div").css("display", "inline-block"),
                        pSteps[a.replace("step-", "step")][o.replace("materialSettings", "name")] && (t = pSteps[a.replace("step-", "step")][o.replace("materialSettings", "name")]),
                        t || (t = $(e.target).find("span").length ? $(e.target).find("span").html().trim() : $(e.target).html().trim()),
                        t == r
                            ? $(
                                  $('[data-step="' + a + '"][data-button="' + o + '"]')
                                      .find("span")
                                      .get(0)
                              ).html(t)
                            : $(
                                  $('[data-step="' + a + '"][data-button="' + o + '"]')
                                      .find("span")
                                      .get(0)
                              ).html(t + " | " + r),
                        DIVERGEVIEWER.changeShoeFabric &&
                            "landscape_canvas" != oParams.productType &&
                            "twist_low" != oParams.productType &&
                            "twist_high" != oParams.productType &&
                            (("minimal" != oParams.productType && "minimal_high" != oParams.productType) || a.replace("-", "_") + "_" + o.replace("-", "_").replace("-materialSettings", "") != "step_1_region_2"
                                ? DIVERGEVIEWER.changeShoeFabric(
                                      a.replace("-", "_") + "_" + o.replace("-", "_").replace("-materialSettings", ""),
                                      $(e.target).find("span").length ? $(e.target).find("span").html().trim().replace("-", "_") : $(e.target).html().trim().replace("-", "_")
                                  )
                                : DIVERGEVIEWER.changeShoeFabric("step_2_region_1", $(e.target).find("span").length ? $(e.target).find("span").html().trim().replace("-", "_") : $(e.target).html().trim().replace("-", "_"))),
                        window.animFabric && a.replace("-", "_") + "_" + o.replace("-", "_").replace("-materialSettings", "") == "step_1_region_1" && DIVERGEVIEWER.animFabric("step_1_region_1", 10);
                }),
            $(".values-controls .bbb").on("click touchstart", function (e) {
                e.stopPropagation();
                var t = $(this).data("step"),
                    o = $(this).data("button"),
                    a = !1,
                    r = $(this).data("color"),
                    i = $(this).data("color-name"),
                    s = $(this).data("material"),
                    l = $(this).parent().find(".tooltiptext"),
                    n = $(this).data("regions-info");
                if (
                    ($(".values-step-" + t + '-controls [data-regions-info="' + n + '"][data-material="' + s + '"]').removeClass("sel-color"),
                    isMobile() && ($(window.document).find(".tooltiptext").css("visibility", "hidden").css("opacity", "1").css("bottom", "125%"), l.css("visibility", "initial"), l.css("opacity", "1")),
                    cProduct["step" + t] || (cProduct["step" + t] = {}),
                    -1 !== DIVERGEVIEWER.getAvailableShoePartsList().indexOf("step_6_region_2") &&
                        ("pride" == i ? DIVERGEVIEWER.changeShoeFabric("step_6_region_2", "pride") : 6 == t && "region-2-materialSettings" == n && DIVERGEVIEWER.changeShoeFabric("step_6_region_2", "default")),
                    r)
                ) {
                    -1 === o.indexOf("region")
                        ? ((a = (a = o.split("-"))[0]), struct_n() ? (cProduct["step" + t][n.replace("Settings", "Selected")] = ":" + s + ":/" + r) : (cProduct["step" + t][s + "-colorSelected"] = "/" + r))
                        : (cProduct["step" + t] || (cProduct["step" + t] = {}),
                          struct_n() ? (cProduct["step" + t][n.replace("Settings", "Selected")] = ":" + s + ":/" + r) : (cProduct["step" + t][o.split("-")[0] + "-" + o.split("-")[1] + "-colorSelected"] = "/" + r)),
                        tinycolor(r).isLight()
                            ? ($('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"]').css("backgroundColor", r),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"] .region-color-label').html(i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"] span').attr("style", "color: #000000 !important"),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"] .region-color-label').attr("style", "color: #000000 !important"))
                            : ($('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"]').css("backgroundColor", r),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"] .region-color-label').html(i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="' + o + '"] span').attr("style", "color: #ffffff !important")),
                        7 == t
                            ? changeShoeMaterialColor("laces_pattern", r.replace("#", "0x"), "step_" + t + "_" + o.replace("-materialSettings", "").replace("-", "_"), n)
                            : (changeShoeMaterialColor(matchMaterial(a || pSteps["step" + t][o]), r.replace("#", "0x"), "step_" + t + "_" + o.replace("-materialSettings", "").replace("-", "_"), n),
                              changeShoeMaterialColor(matchMaterial(s), r.replace("#", "0x"), "step_" + t + "_" + o.replace("-materialSettings", "").replace("-", "_"), n));
                } else {
                    var c = $(this).data("color-one"),
                        p = $(this).data("color-two");
                    c == p ? DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "no_material") : DIVERGEVIEWER.changeShoeFabric("step_6_region_1", "default"),
                        (r = c),
                        changeShoeMaterialColor(matchMaterial("laces_base_color"), c.replace("#", "0x"), "step_" + t + "_" + o.replace("-materialSettings", "").replace("-", "_"), n),
                        cProduct["step" + t] || (cProduct["step" + t] = {}),
                        (cProduct["step" + t].laces_base_color = c),
                        tinycolor("ziggy" != oParams.productType ? c : p).isLight()
                            ? c == p
                                ? ($('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"]').css("backgroundColor", c),
                                  $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] span').attr("style", "color: #000000 !important; font-weight: bold;"),
                                  $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] .region-color-label').attr("style", "color: #000000 !important; font-weight: bold;"))
                                : ($('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"]').css("backgroundColor", c),
                                  $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] span').attr(
                                      "style",
                                      "color: " + ("ziggy" == oParams.productType ? p : "#000000") + " !important; font-weight: bold;"
                                  ),
                                  $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] .region-color-label').attr(
                                      "style",
                                      "color: " + ("ziggy" == oParams.productType ? p : "#000000") + " !important; font-weight: bold;"
                                  ))
                            : c == p
                            ? ($('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"]').css("backgroundColor", c),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] span').attr("style", "color: #ffffff !important; font-weight: bold;"),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] .region-color-label').attr("style", "color: #ffffff !important; font-weight: bold;"))
                            : ($('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"]').css("backgroundColor", c),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] span').attr("style", "color: " + ("ziggy" == oParams.productType ? p : "#ffffff") + " !important; font-weight: bold;"),
                              $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] .region-color-label').attr(
                                  "style",
                                  "color: " + ("ziggy" == oParams.productType ? p : "#ffffff") + " !important; font-weight: bold;"
                              )),
                        $('.regions-controls [data-step="step-' + t + '"][data-button="region-1-materialSettings"] .region-color-label').html(i.lastIndexOf(":") ? i.substring(i.lastIndexOf(":") + 1) : i),
                        changeShoeMaterialColor(matchMaterial("laces_pattern"), p.replace("#", "0x"), "step_" + t + "_" + o.replace("-materialSettings", "").replace("-", "_"), n),
                        (cProduct["step" + t].laces_pattern = p);
                }
                if (
                    (window.colorMouseOver ||
                        ((window.lastColor = r),
                        (window.lastColorEl = $(this)),
                        $(".values-" + t + '-controls [data-regions-info="' + n + '"][data-material="' + s + '"]').removeClass("sel-color"),
                        $(".colorSettings").removeClass("sel-color"),
                        $(".material-p").hide(),
                        $("#product-image-customize").show(),
                        $(this).addClass("sel-color")),
                    "now" == oParams.productType || "now_vegan" == oParams.productType)
                ) {
                    if (struct_n() && 6 == t && "region-1-materialSettings" == n) {
                        var d = $(this).data("color");
                        cProduct.step6["region-1-materialSelected"] = d ? ":laces:/" + d + ";" : ":laces:/" + c + ";/" + p;
                    }
                    if (struct_n() && 6 == t && "region-2-materialSettings" == n) {
                        d = $(this).data("color");
                        cProduct.step6["region-2-materialSelected"] = d && "pride" == i ? ":ribbon:pride/#ffffff;" : ":ribbon:/" + d + ";";
                    }
                }
                window.colorMouseOver = !1;
            }),
            $(".customize-product-header-right .close").on("click", function () {
                localStorage.setItem("open_mini", "1")
                window.location.reload()
                return
              
                $("#shopify-section-header").css("z-index", "9"),
                    $(".customize-product").fadeOut("100"),
                    $(".zopim").show(),
                    $(".logo--left").show(),
                    $(".grid.product-single").show(),
                    $(".tabs-details-product").show(),
                    $(".grid.grid--no-gutters").show(),
                    $("body.template-product").css({ overflow: "initial" }),
                    $("body").css({ overflow: "scroll" });
            }),
            $(".close-symbol-modal").on("click", function () {
                $(".symbol-modal").hide();
            });
    });
var raycaster,
    mouse = { x: 0, y: 0 };
function capture() {
    (raycaster = new THREE.Raycaster()), window.allc.render.renderer.domElement.addEventListener("click", raycast, !1);
}
function raycast(e) {
    (mouse.x = (e.clientX / window.innerWidth) * 2 - 1), (mouse.y = (-e.clientY / window.innerHeight) * 2 + 1), raycaster.setFromCamera(mouse, window.allc.camera);
    var t = raycaster.intersectObjects(window.allc.scene.scene.children[0].children, !0);
    if (t.length) {
        var o = t[0].point;
        (o.y = o.y.toFixed(2)),
            (o.z = o.z.toFixed(2)),
            ((o.y < 0.6 && o.y > -6.5 && o.z >= -20 && o.z <= 5.7) || (o.y < -1.61 && o.y > -5.17 && o.z >= 5.7 && o.z <= 19)) &&
                (DIVERGEVIEWER.animFabric("step_3_region_1"),
                ("none" != $(".regions-step-3-controls.regions-controls").css("display") && $(".regions-step-3-controls.regions-controls").css("display")) || $('.principal-controls [data-button="step-3-controls"]').click());
    }
}
function preData() {
    for (ob in pSteps)
        for (obn in pSteps[ob])
            -1 !== obn.indexOf("materialSettings") && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]),
                -1 !== obn.indexOf("colorSettings") && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]),
                "region-1" == obn && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]),
                "region-2" == obn && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]),
                "region-3" == obn && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]),
                "region-4" == obn && ((pSteps[ob][obn] = void 0), delete pSteps[ob][obn]);
    if ("undefined" != typeof cProduct)
        for (ob in cProduct)
            for (obn in cProduct[ob])
                -1 !== obn.indexOf("materialSettings") && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]),
                    -1 !== obn.indexOf("colorSettings") && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]),
                    "region-1" == obn && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]),
                    "region-2" == obn && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]),
                    "region-3" == obn && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]),
                    "region-4" == obn && ((cProduct[ob][obn] = void 0), delete cProduct[ob][obn]);
}
for (var rC = $(".regions-controls"), protection = "E668AFD26A4808532E4704D55E405392", i = 0; i < rC.length; i++)
    for (var stepId = rC[i].className.replace("regions-controls", "").replace("regions-", "").replace("-controls", "").trim(), rCels = $(rC[i]).find("li"), s = 0; s < rCels.length; s++) {
        var region = $(rCels[s]).data("button").replace("-materialSettings", "").trim(),
            relatedEl = $('[data-step="' + stepId + '"][data-region="' + region + '-materialSettings"]');
        if (1 == relatedEl.length) {
            var regionEl = $(rCels[s]),
                regionElSpan = $($(rCels[s]).find("span").get(0));
            regionEl.attr("data-one-material", "true"), regionElSpan.html(relatedEl.html());
        }
    }
for (var ob in pSteps) {
    var rg = $(".materials-step-" + ob.replace("step", "") + "-controls.materials-controls .controls");
    for (i = 0; i < rg.length; i++) {
        for (var ls = $(rg[i]).find("ul li"), r = 0; r < ls.length; r++) "" == $($(ls[r]).find("span")[0]).html().trim() && $(ls[r]).remove(), delete ls[r];
        if (ls.length > 1)
            if (ls.length % 2 == 0) var ns = ls.length / 2;
            else ns = Math.trunc(ls.length / 2);
    }
}
function fixUIwebview() {
    if (isInstagramApp() && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        console.info("Using Instagram Browser under iOS");
        $(".customize-controls").position().top;
        $(".customize-content-area").css("height", "100vh"),
            window.sizeSelector && ($(".customize-controls").css("minHeight", "360px"), $(".customize-product .customize-product-wrapper .inner").css("top", "140px")),
            $(".customize-controls").css("top", window.sizeSelector ? "800px" : "816px"),
            setInterval(function () {
                $("canvas").attr("style", "margin: -100px 0px 0px"),
                    $(".customize-controls")
                        .css("position", "fixed")
                        .css("top", (window.sizeSelector ? $(window).height() - 80 : $(window).height() / 1.17) - $(".customize-controls-area").height() + "px"),
                    $(".customize-content-area").css("margin-top", window.sizeSelector ? "-10px" : "-50px");
            }, 100);
    }
}
